module.exports = __webpack_public_path__ + "static/bg-f46ca3a836f1d665f84ab64fc95f7465.png";